import { useEffect, useRef } from 'react';

export function useClickOutside(
  refs: React.RefObject<HTMLElement>[],
  handler: () => void,
  enabled: boolean = true,
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) {
      return;
    }
    function handleClick(event: MouseEvent) {
      if (refs.every((ref) => ref.current && !ref.current.contains(event.target as Node))) {
        handlerRef.current();
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [refs, enabled]);
}
